module.exports = __webpack_public_path__ + "img/user-left-02.c00fcbc3.svg";